import { render } from "./SupportHub.vue?vue&type=template&id=2742b87e"
import script from "./SupportHub.vue?vue&type=script&lang=js"
export * from "./SupportHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__